import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "flex flex-col justify-center" }
const _hoisted_2 = { class: "flex flex-col justify-center bg-orangeLight rounded-xl py-5 tablet:py-14 px-5" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h3", { class: "text-lg font-semibold p-5 text-orangeDark" }, "Užitečné dokumenty", -1)
const _hoisted_4 = { class: "flex flex-col" }
const _hoisted_5 = ["href"]

import uzitecneDokumenty from "../../../public/data/uzitecneDokumenty";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(uzitecneDokumenty), (item) => {
          return (_openBlock(), _createElementBlock("a", {
            href: 'PDFs/uzitecneDokumenty/' + item.document,
            target: "_blank",
            key: item.title,
            class: "bg-orange text-white m-2 p-2 rounded laptop:hover:scale-105 transition"
          }, _toDisplayString(item.title), 9, _hoisted_5))
        }), 128))
      ])
    ])
  ]))
}
}

})